import ReportWithoutCriteria from '../ReportWithoutCriteria';
import {
  REFERRED_LEADS_REPORT_ERROR,
  REFERRED_LEADS_REPORT_LOADING,
  REFERRED_LEADS_REPORT_SUCCESS,
} from './reportStates';

export default function ReferredLeadsReport({
  generateReferredLeadsReport,
  getLatestReferredLeadsReport,
  referredLeadsReportData,
  referredLeadsReportState,
}) {
  return (
    <ReportWithoutCriteria
      name="Referred Leads Report"
      link={referredLeadsReportData.link}
      currentState={referredLeadsReportState}
      stateLoading={REFERRED_LEADS_REPORT_LOADING}
      stateError={REFERRED_LEADS_REPORT_ERROR}
      stateSuccess={REFERRED_LEADS_REPORT_SUCCESS}
      getLatestFunc={getLatestReferredLeadsReport}
      generateFunc={generateReferredLeadsReport}
    />
  );
}
